import { useAuthQuery } from 'features/common/apiUtils/queryHelper';
import { groupsApiConfig } from 'features/user-groups/api/config';

interface OrgGroup {
  id: string;
  name: string;
  description: string;
  roles?: Array<{
    role: string;
    scope: string;
    tenantId: string | null;
  }>;
}

interface OrgGroupApiResponse {
  data: OrgGroup[];
}

const {
  get_groups: { url, scope, queryKey },
} = groupsApiConfig;

export const useOrgGroups = () => {
  return useAuthQuery<OrgGroupApiResponse>(
    queryKey,
    async (axiosInstance) => {
      const response = await axiosInstance?.get<OrgGroupApiResponse>(url);
      return response?.data ?? { data: [] };
    },
    {},
    scope,
  );
};
